import { REPORTS_API } from "redux/api";

const generateQueryParams = (payload) => {
    let query = "";
    if(payload?.locationId){
        query+="&locationId="+payload?.locationId
    }else if(payload?.locationid){
        query+="&locationId="+payload?.locationid
    }

    if(payload?.startDate){
        query+="&startDate="+payload?.startDate
    }
    if(payload?.endDate){
        query+="&endDate="+payload?.endDate
    }

    if(payload?.tablePageNo){
        query+="&page="+payload?.tablePageNo
    }else if(payload?.page){
        query+="&page="+payload?.page
    }
    if(payload?.tableRecordLimit){
        query+="&size="+payload?.tableRecordLimit
    }else if(payload?.size){
        query+="&size="+payload?.size
    }
    if(payload?.searchQuery){
        query+="&search="+payload?.searchQuery
    }else if(payload?.search){
        query+="&search="+payload?.search
    }

    if (payload?.itemIds?.length > 0) {
        query += `&itemIds=${(payload?.itemIds || [])?.join(",")}`;
    } else if (payload?.categoryIds?.length > 0) {
        query += `&categoryIds=${(payload?.categoryIds || [])?.join(",")}`;
    }else if(payload?.groupByCategory){
        query+=`&groupByCategory=${payload?.groupByCategory}`
    }
    if(payload?.reason){
        query+=`&reason=${payload?.reason}`
    }
    if(payload?.offer){
        query+=`&offer=${payload?.offer}`
    }
    if(payload?.type){
        query+=`&type=${payload?.type}`
    }
    return "?"+query?.slice(1)
}

export const getLiveCheckInOverview = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/checkin-overview${query}`,
    });
};

export const getLiveSeaterAvailability = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/seater-wise-availability${query}`,
    });
};

export const getLiveGuestCount = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/inqueue-guest-count${query}`,
    });
};

export const getLiveCheckInStatus = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/status-checkin${query}`,
    });
};

export const getLiveAvgWaitTime = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/average-wait-time${query}`,
    });
};

export const getLiveGroupAvgWaitTime = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/average-wait-time-by-groups${query}`,
    });
};

export const getLiveCheckInTable = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/liveortoday-checkins${query} `,
    });
};

export const getLiveCheckInToday = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/live/checkin/liveortoday-checkins${query}`,
    });
};

export const getCheckInOverview = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/totals${query}`,
    });
};

export const getCheckInOverviewHourly = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/hourlyCheckin${query}`,
    });
};

export const getCheckInOverviewGuestsHourly = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/hourlyGuests${query}`,
    });
};

export const getCheckInOverviewDailyAndGuest = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/daily-checkIns-and-guests${query}`,
    });
};

export const getCheckInOverviewDineInGroup = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/dineInDuration${query}`,
    });
};

export const getCheckInOverviewGuestSize = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/guestSizeDistribution${query}`,
    });
};

export const getCheckInOverviewTableDetails = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/checkin-details${query}`,
    });
};

export const getCheckInOverviewTopCustomer = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/top-repeat-customers${query}`, // REPORTS_API not recieved
    });
};

export const getCheckInOverviewAvgWaitTimeGroup = (params) => {
    const query = generateQueryParams(params);
    return REPORTS_API({
        method: "get",
        url: `/checkin/overview/avgWaitTimeByGroup${query}`,// REPORTS_API not recieved
    });
};
